/**
 * @desc 查询交易动态
 */
import { OrderMallDto } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryTransactionDynamicsParameter = never

const method = 'GET'
const url = '/trade/order/mall/queryTransactionDynamics'

export const queryTransactionDynamicsApi = (
  params?: QueryTransactionDynamicsParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<OrderMallDto>>({
    method,
    url,
    params,
    ...config
  })
}

queryTransactionDynamicsApi.method = method
queryTransactionDynamicsApi.url = url
